import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updatePageSeo } from '../lib/pageSeo';
export default function PageSeo() {
  const { pathname, search } = useLocation();
  useEffect(() => { updatePageSeo(pathname, search); }, [pathname, search]);
  return null;
}
